/* eslint-disable max-classes-per-file */
import { ExperienceCardItemClassInterface } from "./ResponseExperienceCardInterface";

export interface RequestGetLandingSectionInterface {
  sectionType: string;
  lang?: string;
}

export interface ResponseGetLandingSectionInterface {
  status: boolean;
  message: string;
  data: Data;
}

export interface Data {
  landingName: string;
  sectionType: string;
  selectType: string;
  tabs: Tab[];
}

export interface Tab {
  tabName: string;
  experienceInfo: ExperienceCardItemClassInterface[] | null;
}

class GetLandingSectionTabClass {
  readonly tabName: string = "";

  readonly experienceInfo: ExperienceCardItemClassInterface[] | null = null;

  constructor(data: Tab) {
    this.tabName = data.tabName || "";
    this.experienceInfo = (data.experienceInfo || []).map(
      (results: ExperienceCardItemClassInterface) =>
        new ExperienceCardItemClassInterface(results),
    );
  }
}

class GetLandingSectionDataClass {
  readonly landingName: string = "";

  readonly sectionType: string = "";

  readonly selectType: string = "";

  readonly tabs: Tab[] = [];

  constructor(data: Data) {
    this.landingName = data.landingName || "";
    this.sectionType = data.sectionType || "";
    this.selectType = data.selectType || "";
    this.tabs = (data.tabs || []).map(
      (results: Tab) => new GetLandingSectionTabClass(results),
    );
  }
}

export class ResponseGetLandingSectionClass {
  readonly status: boolean = false;

  readonly message: string = "";

  readonly data: Data | null = null;

  constructor(data: ResponseGetLandingSectionInterface) {
    this.status = data.status || false;
    this.message = data.message || "";
    this.data = new GetLandingSectionDataClass(data.data || null);
  }
}
